import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
 
  <BrowserRouter>
    <App />
  </BrowserRouter>
 
);
